import dateFormat from "dateformat";

export const getHomeChartOption = (title, color, plotData) => {
	return {
		chart: {
			type: "line",
			height: 350,
		},
		title: {
			text: title.toUpperCase(),
			align: "left",
		},
		colors: [color],
		fill: {
			type: "gradient",
			gradient: {
				opacityFrom: 0.9,
				opacityTo: 0.5,
				stops: [0, 100],
			},
		},
		dataLabels: {
			enabled: false,
		},
		stroke: {
			width: 2,
			colors: [color],
		},
		markers: {
			size: 4,
			colors: [color],
			strokeColor: "#fff",
			strokeWidth: 2,
		},
		xaxis: {
			categories: plotData.map(item => item.date),
			labels: {
				formatter: (val) => dateFormat(val, 'dd/mm'),
			},
			tickPlacement: 'on',
			tickAmount: 6
		},
		yaxis: {
			labels: {
				formatter: (val) => val.toLocaleString(),
			},
		},
	};
}

export default {};
